/**
 * AI生成内容提示组件
 *
 * 根据国家规定，在AI生成内容区域底部显示提示信息
 */

import React from 'react';

interface AIGeneratedNoticeProps {
  className?: string;
  variant?: 'block' | 'inline';
}

export const AIGeneratedNotice: React.FC<AIGeneratedNoticeProps> = ({
  className = '',
  variant = 'inline',
}) => {
  if (variant === 'inline') {
    return (
      <span className={`text-xs text-gray-400/70 select-none ${className}`}>
        内容由AI生成，请注意甄别
      </span>
    );
  }

  return (
    <div className={`text-center py-1.5 ${className}`}>
      <span className="text-xs text-gray-400/70 select-none">
        内容由AI生成，请注意甄别
      </span>
    </div>
  );
};

export default AIGeneratedNotice;